
import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

interface GxCancelButtonProps {
  handleClose: () => void;
  label?: string;
}

const GxCancelButton: React.FC<GxCancelButtonProps> = ({
  handleClose,
  label = "Cancel", // default fallback
}) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      onClick={handleClose}
      className="gx-drawer-back-button"
    >
      <span className="gx-p12-b gx-drawer-back-button-name">
        {t(label)}
      </span>
    </Button>
  );
};

export default GxCancelButton;
